module.exports = __webpack_public_path__ + "img/dianying.b8047102.png";